import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import styled from 'styled-components';

// Swiper 스타일 임포트
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const SliderContainer = styled.div`
  width: 100%;
  height: 600px;
  @media (max-width: 768px) {
    height: 400px; /* 모바일에서는 높이를 줄임 */
  }
`;

const SlideItem = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${props => props.bg});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
`;

const SlideTitle = styled.h2`
  font-size: 3.5rem;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
  @media (max-width: 768px) {
    font-size: 2rem; /* 모바일에서는 제목 크기 축소 */
    padding: 0 20px;
  }
`;

const SlideDesc = styled.p`
  font-size: 1.2rem;
  opacity: 0.9;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
`;

const MainSlider = () => {
  const slides = [
    { id: 1, title: "주식회사 두성시스템", desc: "실내건축 및 조경식재 전문 기업", img: "/images/bg_building.jpg" },
    { id: 2, title: "최고의 시공 품질", desc: "다년간의 노하우로 완성하는 완벽한 공간", img: "/images/bg_cad.jpg" },
    { id: 3, title: "자연과 사람이 공존하는 공간", desc: "친환경 조경 설계 및 시공 전문", img: "/images/bg_landscape.jpg" },
  ];

  return (
    <SliderContainer>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}      // 슬라이드 사이 간격
        slidesPerView={1}      // 한 번에 보일 슬라이드 수
        speed={1000}           // 슬라이딩 속도 (1초 동안 부드럽게 이동)
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}            // 무한 반복
        style={{ width: '100%', height: '100%' }}
      >
        {slides.map(slide => (
          <SwiperSlide key={slide.id}>
            <SlideItem bg={slide.img}>
              <SlideTitle>{slide.title}</SlideTitle>
              <SlideDesc>{slide.desc}</SlideDesc>
            </SlideItem>
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderContainer>
  );
};

export default MainSlider;